/**
 * Returns a promise that 'resolves' on timeout
 * @param ms - time in milliseconds to timeout
 * @param responseFn - optional function to call on timeout.
 */
export function resolveOnTimeout<T>(
  ms: number,
  responseFn?: () => T
): Promise<T | void> {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(responseFn && responseFn());
    }, ms);
  });
}
